import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from "@mui/material";
import { Check } from "@mui/icons-material";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useSettingContext } from "context/SettingContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { getSpecificRates, updateRateMaster, useRateMasterChartData, useSelectUser } from "../apis/RateMasterApi";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border: 1px solid #fff;
  max-height: 75vh;
  overflow: auto;
  background: #000;
  position: relative;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const StyledTable = styled(Table)(({}) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      padding: "10px 5px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    // backgroundColor: "#444444",
    height: "50px",
    // position: "sticky",
    // top: 0,
    // zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(TableCell)`
  width: 20%;
  padding: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
  border: none !important;
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 5px;
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  width: 20%;
  padding: 10px;
  text-align: center;
`;

const CustomUncheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: 2px solid white;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomCheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background-color: #50c878;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  & svg {
    width: 20px;
    height: 20px;
  }
`;

// const initialData = [
//   { srNo: 1, name: "B2B", ID: 1, currency: "₹", access: false },
//   { srNo: 2, name: "D2C", ID: 2, currency: "₹", access: false },
//   { srNo: 3, name: "B2B-USD", ID: 3, currency: "₹", access: false },
//   { srNo: 4, name: "VVS FG-2K", ID: 4, currency: "₹", access: false },
//   { srNo: 5, name: "Internal", ID: 5, currency: "₹", access: false },
//   { srNo: 6, name: "C.Krishnaiah Chetty & Sons", ID: 6, currency: "₹", access: false },
//   { srNo: 7, name: "Malabar Gold & Diamonds", ID: 7, currency: "₹", access: false },
//   { srNo: 8, name: "Ajaybhai Pansuriya", ID: 8, currency: "₹", access: false },
//   { srNo: 9, name: "Antara Jewellers Pvt Ltd", ID: 9, currency: "₹", access: false },
//   { srNo: 10, name: "Manoj Agarwal IPS", ID: 10, currency: "₹", access: false },
//   { srNo: 11, name: "Manubhai Gems Pvt.Ltd", ID: 11, currency: "₹", access: false },
//   { srNo: 12, name: "VVS GH-2K", ID: 12, currency: "₹", access: false },
//   { srNo: 13, name: "VS-SI-GH-2K", ID: 13, currency: "₹", access: false },
//   { srNo: 14, name: "VS GH-2k", ID: 14, currency: "₹", access: false },
//   { srNo: 15, name: "Diamorn", ID: 15, currency: "₹", access: false },
//   // { srNo: 16, name: "Dummy", ID: 17, access: false },
//   { srNo: 16, name: "VVS EF-2K", ID: 18, currency: "₹", access: false },
//   { srNo: 17, name: "C.Krishnaiah Chetty & Sons till 22 Apr 2025", ID: 19, currency: "₹", access: false },
//   { srNo: 18, name: "Diamorn Exhibition Chart", ID: 22, currency: "₹", access: false },
//   { srNo: 19, name: "BBS", ID: 23, currency: "₹", access: false },
// ];

const RateMasterRights = () => {
  const { setSelectRoleBtnName, setRateMaster, saveRightModalOpen, setSaveRightModalOpen, setSelectRoleOptions, selectRoleOptions, setEnableSaveLimitsBtn, selectRoleBtnName, setVibrateButton } =
    useSettingContext();
  const [tableData, setTableData] = useState([]);
  const [backendRateData, setBackendRateData] = useState([]);

  const { data } = useSelectUser();

  const users = data?.data?.User;

  const { data: initialData } = useRateMasterChartData();

  // {
  // "RateChartId": 1,
  // "ChartCode": "B2B",
  // "ChartName": "B2B",
  // "CurrencySymbol": "₹"
  // },

   const premission=usePermissions();
  const hasEditAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", premission), "Rate Master Rights"), "edit");
  useEffect(() => {
    setRateMaster(true);
    setSelectRoleBtnName("Select User");
    if (Array.isArray(users)) {
      const options = users?.map((data, index) => ({
        roleName: data?.username,
        userId: data?._id,
      }));
      setSelectRoleOptions(options);
    }
    setTableData(initialData?.map((item) => ({ ...item, access: false })));
    return () => {
      setRateMaster(false);
      setSelectRoleOptions([]);
      setSelectRoleBtnName("");
      setEnableSaveLimitsBtn(false);
      setVibrateButton(false);
      setTableData([]);
    };
  }, [users, initialData]);

  const compareChanges = () => {
    let getNewRateMaster = tableData.filter((labor) => labor.access === true).map((labor) => labor.ChartName);

    let noChange = backendRateData.length === getNewRateMaster.length && [...backendRateData].sort().every((val, i) => val === [...getNewRateMaster].sort()[i]);
    return !noChange;
  };

  const handleCheckboxChange = (index) => {
    if (index !== 1 && tableData[index].ChartName !== "C2C") {
      const updatedData = [...tableData];
      updatedData[index].access = !updatedData[index].access;
      setTableData(updatedData);
      setEnableSaveLimitsBtn(compareChanges());
    }
  };

  const discardChanges = () => {
    setSaveRightModalOpen(false);
  };

  const handleSaveRates = async () => {
    if (!selectRoleBtnName || selectRoleBtnName === "Select User") return;

    const rateCards = tableData.filter((item) => item.access)?.map((item) => ({ name: item.ChartName, ID: item.RateChartId, currencySymbol: item.CurrencySymbol }));

    const selectedUser = selectRoleOptions.find(({ roleName }) => roleName === selectRoleBtnName);

    if (!selectedUser?.userId) {
      alert("User not found for selected role");
      return;
    }

    const payload = {
      userId: selectedUser.userId,
      rateCards,
    };

    try {
      const { status } = await updateRateMaster(payload);

      if (status === 200) {
        setSaveRightModalOpen(false);
        setEnableSaveLimitsBtn(false);
      }
    } catch (error) {
      console.error("Error updating rate master:", error);
    }
  };

  const btnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => {
        discardChanges();
      },
    },
    {
      btnName: "Yes",
      bgColor: "#50c878",
      click: () => {
        handleSaveRates();
      },
    },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const selectedUser = selectRoleOptions.find(({ roleName }) => roleName === selectRoleBtnName);

        if (!selectedUser?.userId) return;

        const rates = await getSpecificRates(selectedUser.userId);

        if (rates?.status === 200 && Array.isArray(rates.rateCards)) {
          const updatedTableData = initialData?.map((item) => ({
            ...item,
            access: rates.rateCards.includes(item.ChartName),
          }));

          setTableData(updatedTableData);
          setBackendRateData(rates.rateCards);
        } else {
          const clearedTableData = initialData?.map((item) => ({
            ...item,
            access: false,
          }));
          setTableData(clearedTableData);
        }
      } catch (error) {
        console.error("Error fetching rate master for user", error);
        const clearedTableData = initialData?.map((item) => ({
          ...item,
          access: false,
        }));
        setTableData(clearedTableData);
      }
    };

    if (selectRoleBtnName && selectRoleBtnName !== "Select User") {
      fetchUsers();
    }
  }, [selectRoleBtnName]);

 
  const formatCurrency = (currency) => {
    let filterCurrency = currency.replace(/[A-Za-z]/g, "").trim();
    return filterCurrency ? filterCurrency : currency.trim();
  };

  return (
    <>
      <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px", backgroundColor: "#000", padding: "10px" }}>
        <StyledTableContainer>
          <StyledTable>
            <TableHead>
              <TableRow>
                <StyledTableHeaderCell>Sr no.</StyledTableHeaderCell>
                <StyledTableHeaderCell>Rate Chart Name</StyledTableHeaderCell>
                <StyledTableHeaderCell>Rate Chart ID</StyledTableHeaderCell>
                <StyledTableHeaderCell>Currency</StyledTableHeaderCell>
                <StyledTableHeaderCell>Access</StyledTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((item, i) => (
                <StyledTableRow key={i}>
                  <StyledTableBodyCell>{i + 1}.</StyledTableBodyCell>
                  <StyledTableBodyCell>{item?.ChartName}</StyledTableBodyCell>
                  <StyledTableBodyCell>#{item?.RateChartId}</StyledTableBodyCell>
                  <StyledTableBodyCell>{formatCurrency(item?.CurrencySymbol)}</StyledTableBodyCell>
                  <StyledTableBodyCell>
                    <Checkbox
                      disableRipple
                      disabled={!hasEditAccess}
                      checked={item?.access}
                      onChange={selectRoleBtnName === "Select User" ? () => setVibrateButton(true) : () => handleCheckboxChange(i)}
                      icon={<CustomUncheckedIcon />}
                      checkedIcon={
                        <CustomCheckedIcon>
                          <Check />
                        </CustomCheckedIcon>
                      }
                      sx={{ cursor: hasEditAccess && i !== 1 ? "pointer" : "default" }}
                    />
                  </StyledTableBodyCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </div>
      <RemoveModal open={saveRightModalOpen} setOpen={setSaveRightModalOpen} btnInfo={btnInfo} heading="Do you want to save access changes?" />
    </>
  );
};

export default RateMasterRights;
